export default "__VITE_ASSET__8XQqg2uX__"